import { useId as useReactId } from "react";

export const useId = (idProp?: string) => {
  const id_ = useReactId();
  return idProp ?? id_;
};
